import { OneTimePurchaseProviders, currencySchema, oneTimePurchaseOptionsSchema, providerResultSchema } from "../../../../payment/shared.mjs";
import { z } from "zod";
//#region src/api/orpc/payment/surprisePack/schemas.ts
/**
* Mirror of `SurprisePackType` / `SurprisePackStatus` /
* `UserSurprisePackStatus` from the server's
* `service/helper/payment/surprisePack/constants.ts`. Kept inline so the
* contract package stays free of server-only imports; canonical
* definitions stay on the server alongside the surprisePack service code.
*/
const surprisePackTypeSchema = z.enum([
	"micro",
	"small",
	"medium",
	"large",
	"mega"
]);
const surprisePackStatusSchema = z.enum(["active", "archived"]);
const userSurprisePackStatusSchema = z.enum([
	"pending",
	"fulfilled",
	"cancelled"
]);
const membershipBoostTiersSchema = z.object({
	tier1: z.number().int().nonnegative(),
	tier2: z.number().int().nonnegative(),
	tier3: z.number().int().nonnegative()
});
const kaisuukenRewardSchema = z.object({
	templateId: z.string(),
	count: z.number().int().positive(),
	expireDays: z.number().int().positive()
});
const skuSnapshotSchema = z.object({
	id: z.string(),
	eventName: z.string(),
	type: z.string(),
	priceAmountMicros: z.string(),
	currency: z.string(),
	baseCredits: z.number().int(),
	fixedBoostPercent: z.number().int(),
	randomBoostMinPercent: z.number().int(),
	randomBoostMaxPercent: z.number().int(),
	membershipBoostTiers: membershipBoostTiersSchema,
	kaisuukenRewards: z.array(kaisuukenRewardSchema),
	decorationCodes: z.array(z.string()),
	purchaseLimit: z.number().int(),
	status: z.string(),
	kotoneCreditAmount: z.number().int().nonnegative().nullable().optional()
});
const surprisePackSKUSchema = z.object({
	id: z.string(),
	eventName: z.string(),
	type: surprisePackTypeSchema,
	priceAmountMicros: z.coerce.bigint(),
	currency: currencySchema,
	displayAmount: z.string(),
	baseCredits: z.int().nonnegative(),
	fixedBoostPercent: z.int().nonnegative(),
	randomBoostMinPercent: z.int().nonnegative(),
	randomBoostMaxPercent: z.int().nonnegative(),
	membershipBoostTiers: membershipBoostTiersSchema,
	kaisuukenRewards: z.array(kaisuukenRewardSchema),
	decorationCodes: z.array(z.string()),
	purchaseLimit: z.int().positive(),
	status: surprisePackStatusSchema,
	appStoreId: z.string().nullable(),
	googlePlayId: z.string().nullable(),
	kotoneCreditAmount: z.int().nonnegative().nullable(),
	purchasedCount: z.int().nonnegative()
});
const userSurprisePackSchema = z.object({
	id: z.string(),
	userId: z.coerce.bigint(),
	eventName: z.string(),
	type: surprisePackTypeSchema,
	orderId: z.coerce.bigint(),
	status: userSurprisePackStatusSchema,
	skuSnapshot: skuSnapshotSchema,
	randomBoostPercent: z.int().nullable(),
	totalCredits: z.int().nullable(),
	createdAt: z.iso.datetime()
});
const purchaseResultSchema = z.object({
	orderId: z.coerce.bigint(),
	provider: z.enum(OneTimePurchaseProviders),
	userSurprisePack: userSurprisePackSchema.optional(),
	providerResult: providerResultSchema.optional()
});
const purchaseInputSchema = oneTimePurchaseOptionsSchema.extend({
	eventName: z.string(),
	surprisePackType: surprisePackTypeSchema,
	currency: currencySchema
});
//#endregion
export { kaisuukenRewardSchema, membershipBoostTiersSchema, purchaseInputSchema, purchaseResultSchema, skuSnapshotSchema, surprisePackSKUSchema, userSurprisePackSchema };
